import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, ConfigProvider } from 'antd';
import VetIcon from './icons/VetIcons';
import './styles.css';

const heroImage = 'https://cms.e-feed.ru/wp-content/uploads/2023/01/Group-710-2048x1619.png';

const serviceSteps = [
    'Предоставление FTA-карты',
    'Отбор патологического материала от животного, аборт плода',
    'Перенос материала на FTA-карту.',
    'Подготовка FTA-карты к пересылке (сушка, упаковка)',
    'Выбор ветеринарной лаборатории для исследования',
    'Оформление сопроводительного документа',
    'Пересылка в лабораторию',
    'Получение результатов лаборатории',
    'На основе результатов составляются рекомендации по профилактике, лечению, эрадикации возбудителя.',
];

const advantages = [
    'ПЦР исследования. Быстрый и точный результат, т. к. определяет ДНК возбудителя.',
    'Выбор лаборатории независимо от расстояния (вплоть до использования зарубежных лабораторий.',
    'Информация о результате доступна только клиенту',
    'Безопасность использования за счет включенных химических веществ',
    'Отбор материала прост, хранение не требует отрицательных температур.',
    'Широкий спектр исследований',
    'Материал исследуется в независимой лаборатории. При получении положительных результатов ограничения не устанавливаются.',
];

const research = [
    {
        title: 'Возбудители абортов',
        desc: 'скрининг (Coxiella burnetii, Chlamydophila spp., Listeria monocytogenes, Salmonella spp., Campylobacter fetus, патогенные Leptospira, Anaplasma phagocytophila, вирус герпеса КРС 4 типа, ИРТ, ВД), комплекс , ПЦР',
    },
    {
        title: 'Возбудители респираторных инфекций',
        desc: 'скрининг (Mycoplasma bovis, Histophilus somni, Pasteurella multocida, Mannheimia haemolitica, коронавирус, РСИ, ПГ-3, ИРТ), комплекс, ПЦР',
    },
    {
        title: 'Возбудители инфекций ЖКТ у взрослых животных',
        desc: 'скрининг (вирусная диарея, коронавирус КРС, Clostridium perfringens факторы вирулентности), комплекс, ПЦР',
    },
    {
        title: 'Возбудители инфекций ЖКТ у телят',
        desc: 'скрининг (ротавирус А, ротавирус С, коронавирус КРС, Clostridium perfringens факторы вирулентности, Cryptosporidium spp., бактерии рода Salmonella, патогенные E.coli), комплекс, ПЦР',
    },
    {
        title: 'Диагностика маститов',
        desc: 'базовый скрининг основных патогенов (Staphylococcus spp., Streptococcus spp., Mycoplasma spp., Ureaplasma spp.) комплекс, ПЦР',
    },
];

const VetLab = () => {
    const navigate = useNavigate();

    return (
        <ConfigProvider
            theme={{
                token: { colorPrimary: '#D00202' },
                components: { Button: { colorPrimaryHover: '#ff3333' } },
            }}
        >
            <div className="vetlab-page">
                <div className="vetlab-container">
                    <h1 className="vetlab-title">Ветеринарная лаборатория</h1>

                    <section className="vetlab-section">
                        <p className="vetlab-subtitle">
                            <strong>FTA-карта</strong> — для исключения или определения возбудителя заболевания.
                        </p>

                        <div className="vetlab-hero">
                            <img src={heroImage} alt="FTA-карта" className="vetlab-hero-img" />
                            <div className="vetlab-hero-text">
                                <p>Современный способ сбора биологического материала для проведения исследований.</p>
                                <p>
                                    Актуален при проявлениях диареи, мастита, респираторных патологий, а также при абортах
                                    и мертворождении у сельскохозяйственных животных.
                                </p>
                            </div>
                        </div>
                    </section>

                    <section className="vetlab-section">
                        <h2 className="vetlab-section-title-center">Услуга включает в себя</h2>
                        <div className="vetlab-steps">
                            {serviceSteps.map((text, i) => (
                                <div className="vetlab-step" key={i}>
                                    <VetIcon index={i} alt={text} />
                                    <p>{text}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="vetlab-section">
                        <p>
                            FTA-карты применяют для сбора, хранения и транспортировки биологического материала, направленного
                            на генетический анализ ДНК. Для выявления заболеваний или исследования образцов на присутствие
                            возбудителей болезни для точной диагностики и лечения. А также для быстрого подтверждения болезни
                            за счет исследования методом полимерной цепной реакции (ПЦР)
                        </p>
                    </section>

                    <section className="vetlab-section">
                        <h2 className="vetlab-section-title-center">Преимущества использования FTA-карты:</h2>
                        <ol className="vetlab-advantages">
                            {advantages.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ol>
                    </section>

                    <section className="vetlab-section">
                        <h2 className="vetlab-section-title-center">Виды исследований</h2>
                        <div className="vetlab-research-table">
                            {research.map((item, i) => (
                                <div className={`vetlab-research-row ${i % 2 === 0 ? 'vetlab-research-row--even' : ''}`} key={i}>
                                    <div className="vetlab-research-title"><strong>{item.title}</strong></div>
                                    <div className="vetlab-research-desc">{item.desc}</div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <div className="vetlab-order-btn">
                        <Button
                            type="primary"
                            size="large"
                            block
                            onClick={() => navigate('/product/283328')}
                        >
                            Заказать услугу
                        </Button>
                    </div>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default VetLab;
